/**
 * OAuth return path survives full-page redirects to providers (session-scoped, not global localStorage).
 */
const SESSION_KEY = "oauth_return_path"
const LEGACY_LOCAL_KEY = "redirectAfterOAuth"

export function setOAuthReturnPath(path) {
  if (path == null || String(path).trim() === "") return
  try {
    sessionStorage.setItem(SESSION_KEY, String(path))
    localStorage.removeItem(LEGACY_LOCAL_KEY)
  } catch {
    /* ignore */
  }
}

export function getOAuthReturnPath() {
  try {
    let path = sessionStorage.getItem(SESSION_KEY)
    if (!path) {
      const legacy = localStorage.getItem(LEGACY_LOCAL_KEY)
      if (legacy) {
        sessionStorage.setItem(SESSION_KEY, legacy)
        localStorage.removeItem(LEGACY_LOCAL_KEY)
        path = legacy
      }
    }
    return path
  } catch {
    return null
  }
}

export function clearOAuthReturnPath() {
  try {
    sessionStorage.removeItem(SESSION_KEY)
    localStorage.removeItem(LEGACY_LOCAL_KEY)
  } catch {
    /* ignore */
  }
}
